<script lang="ts">
  import { RadioTile, TileGroup } from "carbon-components-svelte";
  import { optionsData } from "./../../ts/Stores";
  import type { IColor } from "./../../ts/Interfaces";

  let values: IColor[];

  optionsData.subscribe((optionsData) => {
    values = optionsData.canvasOptions.colors;
  });

  export let selected: IColor;
</script>

<TileGroup class="flex-wrap">
  {#each values as value, index}
    <RadioTile
      value={value.code}
      class="bg-{value.code}"
      on:change={(e) => {
        selected = values.at(index);
      }}
    >
      {value.name}
    </RadioTile>
  {/each}
</TileGroup>
